import React from "react";
import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    placeholder?: string;
    selectedItems: AutoCompleteDataModel[];
    multiSelect: boolean;

    onChange: (item: AutoCompleteDataModel[]) => void;
    onError: (error: any) => void;
}


////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de status de login
 * @param props
 */
export const LoginStatusAutoComplete: React.FC<IProps> = (props) => {

    const api = useCoreApi();

    const { placeholder, selectedItems, multiSelect, onChange, onError } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.groupRuleLoginStatus({
                name: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
            }, { signal })
            .then(result => resolve({
                items: result.data.items as AutoCompleteDataModel[],
                totalRows: result.data.totalRows
            }))
            .catch(error => {
                if (!isCanceledError(error)) {
                    resolve({ items: [], totalRows: 0 });
                    onError(error);
                }
            });
        });
    };


    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            fullWidth
            label=""
            multiSelect={multiSelect}
            placeholder={placeholder}
            selectedItems={selectedItems}
            onGetSuggestions={getSuggestions}
            onChange={onChange}
        />
    );
};
